module.exports = __webpack_public_path__ + "img/2-5-1.6f7d3aeb.png";